import type { AnalyticsEventName, AnalyticsEventPayloads } from "@murmurations/core";

// Every custom analytics event flows through the single gtag.js instance set up
// in index.html (GA4 measurement id G-ZLNEV7BV28, gated to the murmurations.ar
// host). Page views and these events therefore land in one GA4 property. Off the
// production host — the dev server and staging — `window.gtag` is never defined,
// so this is a safe no-op and no hits reach the live property.
type Gtag = (
  command: "event",
  eventName: string,
  params?: Record<string, string | number>,
) => void;

export function trackAnalyticsEvent<T extends AnalyticsEventName>(
  eventName: T,
  params: AnalyticsEventPayloads[T],
): void {
  if (typeof window === "undefined") return;

  const gtag = (window as unknown as { gtag?: Gtag }).gtag;
  if (typeof gtag !== "function") return;

  try {
    gtag("event", eventName, params as Record<string, string | number>);
  } catch (error) {
    console.warn(`[analytics] Failed to log event "${eventName}"`, error);
  }
}
